import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';

import SegmentAnalytics from '../../helpers/SegmentAnalytics.js';

const imageErrorTypes = {
  dimensions: 'dimensions',
  extension: 'extension',
  unknown: 'unknown'
};

class ImageError extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      closeModal: false
    };
  }

  render() {
    return (
      <Modal
        className="image-error-modal"
        headerText={this.errorTitle()}
        closeModal={this.state.closeModal}
        onModalClose={this.props.onClosed}
        fullScreenOnMobile={false}
      >
        <div className="image-error-modal__content">
          <h3>Oops! Something went wrong.</h3>

          { this.errorMessage() }

          <button onClick={this.close.bind(this)}>
            Try another photo
          </button>
        </div>
      </Modal>
    );
  }

  errorTitle() {
    switch(this.props.errorType){
    case imageErrorTypes.extension:
      return 'Invalid photo type';
    case imageErrorTypes.dimensions:
      return 'Photo too small';
    default:
      return 'Processing error';
    }
  }

  errorMessage() {
    SegmentAnalytics.track('Image error', {
      errorType: this.props.errorType
    });

    switch (this.props.errorType){
    case imageErrorTypes.extension:
      return (
        <React.Fragment>
          <p>It looks like the photo type was invalid. <br/>Supported types are PNG, JPG, BMP and GIF.</p>
        </React.Fragment>
      );
    case imageErrorTypes.dimensions:
      return (
        <React.Fragment>
          <p>It looks like the photo is too small. <br />Minimum photo size is 300x300 pixels.</p>
        </React.Fragment>
      );
    default:
      return (
        <React.Fragment>
          <p>There was an error processing your photo. <br />Please try a different one.</p>
        </React.Fragment>
      );
    }
  }

  close() {
    this.setState({ closeModal: true });
  }
}

ImageError.defaultProps = {
  className: ''
};

ImageError.propTypes = {
  className: PropTypes.string,
  errorType: PropTypes.string.isRequired,
  onClosed: PropTypes.func.isRequired
};

export { imageErrorTypes };
export default ImageError;
